import { isMoveDetailsValid } from '@/modules/yard/components/YardTasksCreateTaskMoveDetails.helpers';

type DueByTime = {
  time?: string;
  amPm?: string;
};

type TaskData = {
  type: string;
  asset?: string;
  originSpot?: string;
  destinationSpot?: string;
  assignee?: string;
  description?: string;
  dueByDate?: string;
  dueByTime?: DueByTime;
  isUrgent?: boolean;
};

/**
 * Validates task data before submission
 * @param taskData - Task data to validate
 */
export function validateTask(taskData: TaskData | null | undefined): boolean {
  if (!taskData) {
    console.error('No task data provided');
    return false;
  }

  if (taskData.type !== 'move') {
    console.error('Invalid task type');
    return false;
  }

  return isMoveDetailsValid(taskData.asset, taskData.destinationSpot);
}
